import { RaRichText, RaTypography } from '@components/core/index.core'

import type {
  BuildingBlockKeyFactsRepeaterItemTableRepeaterProps,
  RoundtripKeyFactsRepeaterItemTableRepeaterProps,
} from '@typings'
import { unescapeHTML } from '@utilities/helpers/unescape-html.helpers'
import clsx from 'clsx'
import styles from './ra-keyfact-without-icon.module.scss'

type KeyfactsRepeaterProps =
  | BuildingBlockKeyFactsRepeaterItemTableRepeaterProps
  | RoundtripKeyFactsRepeaterItemTableRepeaterProps

interface RaKeyfactWithoutIconProps {
  item: KeyfactsRepeaterProps
  directionMobile?: 'row' | 'column'
}

export const RaKeyfactWithoutIcon = ({
  item,
  directionMobile = 'column',
}: RaKeyfactWithoutIconProps) => {
  const keyfact = unescapeHTML(item.text)
  const fixedTitle = item.title.trim()
  const title = fixedTitle ? unescapeHTML(fixedTitle) + ':' : ''

  return (
    <li
      className={clsx(
        styles['keyfact'],
        directionMobile === 'row' && styles['keyfact--row']
      )}>
      <RaTypography
        component="span"
        weight="bold">
        {title}
      </RaTypography>
      <RaRichText content={keyfact} />
    </li>
  )
}
